(function ($) {
	window.pushpay = window.pushpay || {};

	window.pushpay.enableField = function(field) {
		$(field).removeAttr('disabled');
	};

	window.pushpay.disableThenClearIfVisible = function(field) {
		$(field)
			.attr('disabled', 'disabled')
			.not(':hidden')
			.removeAttr('checked')
			.removeAttr('selected')
			.not(':button, :submit, :reset, :radio, :checkbox, select')
			.val('')
			.change();
	};

	$(function () {
		// Add auto-selection to some input:text fields that want it.
		var inputs = $('input:text.selectOnFocus');
		inputs.mouseup(function ( ) { return false; });
		inputs.focus(function () { $(this).select(); });

		// Setup autofocus on form fields
		var autoFocusField = $("[data-action='autoFocus']");
		if (autoFocusField.length) {
			if (!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) { // autoFocus doesn't work so well on touch devices - namely iOS
				autoFocusField.focus();
			}
		}

		// Setup autofocus on form fields
		autoFocusField = $("[data-action='setCursorToEnd']");
		if (autoFocusField.length) {
			if (!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) { // autoFocus doesn't work so well on touch devices - namely iOS
				autoFocusField.focus();
				autoFocusField[0].setSelectionRange(1000, 1000);
			}
		}

		// Go back using browser history
		$(".go-back").click(function (e) {
			e.preventDefault();
			history.go(-1);
		});

		// Auto-jump credit card fields
		var $ccFields = $(".card-entry input");
		if($ccFields.length) {
			$ccFields.eq(0).autoSkip($ccFields.eq(1));
			$ccFields.eq(1).autoSkip($ccFields.eq(2));
			$ccFields.eq(2).autoSkip($ccFields.eq(3));
			$ccFields.eq(3).autoSkip($ccFields.eq(4));
		}

		// Setup confirmation function for buttons
		$("[data-action='confirm']").click(function () {
			var val = $(this).attr("data-value");
			return confirm(val);
		});

		// Auto-populate placeholder text field if empty
		$("[data-action='autopopulate']").blur(function () {
			var val = $(this).val();
			var $placeholderText = $("input." + $(this).attr("data-value"));
			if ($placeholderText.length && !$placeholderText.val().length) {
				$placeholderText.val(val);
			}
		});

		// Toggle payment method visability
		$('[data-action="add-payment-method"]').click(function() {
			$('.available-payment-methods').toggleClass('hidden');

			$("html, body").animate({ scrollTop: $(document).height() - $(window).height() }, 500);
		});


		$("form").on('submit', function (event) {
			if (!event.result) {
				//submit was cancelled, i.e. validate failed.
				return;
			}
			var $form = $(event.target);
			var $button = $form.find("[data-action='preventdoubleclick']");
			$button
				.prop("disabled", true)
				.attr("value", "Sending...")
				.click(function(e) {
					//for safety
					e.preventDefault();
					return false;
				});

			$form.find("[data-action='hideonsubmit']").hide();
		});

		// listing control mobile
		$('.listing-control').change(function(e) {
			window.location = $(e.target).find('option:selected')[0].value;
		});


	});
})(jQuery);
